// extracted by mini-css-extract-plugin
export var component = "ServiceUsage-module--component--kGqLK";
export var table = "ServiceUsage-module--table--lEkEi";
export var title = "ServiceUsage-module--title--ChErG";
export var head = "ServiceUsage-module--head--o4Lrx";
export var th = "ServiceUsage-module--th--pNmz7";
export var td = "ServiceUsage-module--td--2koBF";
export var filter = "ServiceUsage-module--filter--fPUTg";
export var label = "ServiceUsage-module--label--Y8Skn";
export var select = "ServiceUsage-module--select--0Lse3";
export var usageStats = "ServiceUsage-module--usageStats--osssG";